/**
 * The Snipe mark, the same geometry as the app icon in brand/.
 *
 * It keeps its own colours in both themes rather than inverting with the
 * dashboard. An icon is a fixed object: this is what sits on the phone home
 * screen, so a support conversation about "the orange square app" means the
 * same thing on either side of the call.
 */
export function SnipeMark({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      aria-hidden="true"
      className="shrink-0 rounded-[22%]"
    >
      <rect width="1024" height="1024" fill="#0B0E12" />
      <g fill="#EDF1F6" transform="translate(183.99 747.52) scale(0.686647 -0.686647)">
        <path d="M343 -12Q283 -12 229.0 0.0Q175 12 133.5 38.5Q92 65 68.5 105.5Q45 146 45 204Q45 209 45.0 214.5Q45 220 46 223H194Q193 220 193.0 215.0Q193 210 193 206Q193 174 210.5 152.0Q228 130 262.0 119.0Q296 108 341 108Q370 108 392.5 111.5Q415 115 432.5 121.5Q450 128 461.5 137.0Q473 146 478.5 158.0Q484 170 484 185Q484 212 466.5 229.0Q449 246 418.5 258.0Q388 270 350.0 280.0Q312 290 272.0 300.5Q232 311 194.0 326.5Q156 342 126.0 364.0Q96 386 78.0 420.0Q60 454 60 502Q60 553 81.5 590.0Q103 627 142.0 651.0Q181 675 232.0 686.5Q283 698 343 698Q399 698 449.0 686.5Q499 675 537.0 650.0Q575 625 596.5 587.0Q618 549 618 497V485H473V493Q473 520 457.0 539.0Q441 558 412.0 569.0Q383 580 344 580Q302 580 272.5 572.0Q243 564 227.5 548.5Q212 533 212 512Q212 488 229.5 472.5Q247 457 277.5 445.5Q308 434 346.0 425.0Q384 416 424.0 405.0Q464 394 502.0 379.0Q540 364 570.0 341.5Q600 319 618.0 286.0Q636 253 636 207Q636 128 598.0 80.0Q560 32 494.0 10.0Q428 -12 343 -12Z" />
      </g>
      <rect x="667.80" y="606.21" width="141.31" height="141.31" fill="#FF6A2B" />
    </svg>
  );
}
